/* ============================================================
   small talk city — mega menu behaviour

   The dropdown used to be pure CSS :hover. Because the panel sits
   below the whole header, the cursor crossed a dead zone on the way
   down and the menu vanished before you could click anything.

   This keeps it open for CLOSE_DELAY after the cursor leaves, so
   there is time to travel into it, and closes it immediately if you
   move to a different nav item, click away, or press Escape.

   CSS still opens it on :hover, so with JS disabled the old
   behaviour remains rather than nothing at all.
   ============================================================ */
(function () {
  var CLOSE_DELAY = 5000;

  function init(root) {
    var groups = root.querySelectorAll('.has-mega');
    if (!groups.length) return;

    var closeTimer = null;
    var current = null;
    var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;

    function closeMega() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (current) {
        current.classList.remove('is-open');
        var t = current.querySelector('a');
        if (t) t.setAttribute('aria-expanded', 'false');
        current = null;
      }
    }

    function openMega(g) {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (current && current !== g) closeMega();
      g.classList.add('is-open');
      var t = g.querySelector('a');
      if (t) t.setAttribute('aria-expanded', 'true');
      current = g;
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, CLOSE_DELAY);
    }

    Array.prototype.forEach.call(groups, function (g) {
      var trigger = g.querySelector('a');
      if (trigger) {
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      }
      g.addEventListener('mouseenter', function () {
        openMega(g);
      });
      g.addEventListener('mouseleave', scheduleClose);
      g.addEventListener('focusin', function () {
        openMega(g);
      });
      /* touch / no-hover devices: first tap opens, second follows the link */
      if (coarse && trigger) {
        trigger.addEventListener('click', function (e) {
          if (!g.classList.contains('is-open')) {
            e.preventDefault();
            openMega(g);
          }
        });
      }
    });

    /* moving to a different top-level item closes it straight away */
    Array.prototype.forEach.call(
      root.querySelectorAll('.nav > a, .utils a, .mark a'),
      function (a) {
        a.addEventListener('mouseenter', closeMega);
      }
    );

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMega();
    });

    document.addEventListener('click', function (e) {
      if (current && !current.contains(e.target)) closeMega();
    });
  }

  function boot() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.stc--header'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
